import React, { Component } from "react";

import {
  CLabel,
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CSelect,
  CFormGroup
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class AbilityCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      loading: false,
      fields: [],
      creating: false,
      ability_serie: [],
      objectiveOptions: [],
      selectedObjective: "",
      maxLabelLength: 130
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.seriesMount = this.seriesMount.bind(this);
    this.ability_seriesMount = this.abilitySeriesMount.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.handleObjectiveChange = this.handleObjectiveChange.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateMaxLabelLength);
    this.updateMaxLabelLength();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateMaxLabelLength);
  }

  updateMaxLabelLength = () => {
    const width = window.innerWidth;

    let maxLength = 130; // valor padrão
    if (width < 1200) maxLength = 130;
    if (width < 992) maxLength = 100;
    if (width < 768) maxLength = 60;
    if (width < 576) maxLength = 15;

    this.setState({ maxLabelLength: maxLength });
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    const { id } = this.props.match.params;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .get(`${URL.api}classification/serie/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            respserie => {
              axios
                .get(`${URL.api}classification/objective/list`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(
                  respobjective => {
                    // Armazena as opções para usar no select manual
                    const objectiveOptions = respobjective.data.data.map(
                      obj => ({
                        value: obj.id,
                        label: obj.description
                      })
                    );
                    console.log(objectiveOptions);
                    axios
                      .get(`${URL.api}classification/segment/list`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(
                        respsegment => {
                          let fieldsArray = this.fieldsMount();
                          let serie = this.seriesMount(
                            respserie.data.data,
                            respsegment.data.data
                          );
                          this.setState(
                            () => ({
                              fields: fieldsArray,
                              serie,
                              objectiveOptions
                            }),
                            () => {
                              if (!id) {
                                this.setState(() => ({
                                  loading: false
                                }));
                              }
                            }
                          );
                        },
                        error => {
                          this.error("Não foi possível obter as informações");
                        }
                      );
                  },
                  error => {
                    this.error("Não foi possível obter as informações");
                  }
                );
            },
            error => {
              this.error("Não foi possível obter as informações");
            }
          );
      }
    );

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}classification/serie/list`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              respserie => {
                axios
                  .get(`${URL.api}classification/ability/singleView/${id}`, {
                    headers: {
                      authorization: `Bearer ${this.props.user.token}`
                    }
                  })
                  .then(
                    resp => {
                      let abilitySerie = this.abilitySeriesMount(
                        resp.data.data.ability_serie,
                        respserie.data.data
                      );
                      this.setState(
                        () => ({
                          ability: resp.data.data.ability,
                          ability_serie: abilitySerie,
                          selectedObjective:
                            resp.data.data.ability.objective_id || ""
                        }),
                        () => {
                          this.setState(() => ({
                            edit: true,
                            loading: false
                          }));
                        }
                      );
                    },
                    error => {
                      this.error("Não foi possível obter as informações");
                    }
                  );
              },
              error => {
                this.error("Não foi possível obter as informações");
              }
            );
        }
      );
    }
  }

  fieldsMount() {
    let Fields = [
      {
        name: "code",
        label: "Código",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "description",
        label: "Descrição",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      }
    ];

    return Fields;
  }

  seriesMount(value, segmentOptions) {
    function nameSegment(id) {
      let nameSegment;
      for (let k = 0; k < segmentOptions.length; k++) {
        if (segmentOptions[k].id === id) {
          nameSegment = segmentOptions[k].name;
        }
      }

      return nameSegment;
    }

    let optionSerie = [];
    let objNivel;
    let arraySerie;

    for (let i = 0; i < value.length; i++) {
      if (i === 0) {
        objNivel = {};
        arraySerie = [];
        objNivel.label = nameSegment(value[i].segment_id);
        let objSerie = {};
        objSerie.value = value[i].id;
        objSerie.label = value[i].name;
        arraySerie.push(objSerie);
        objNivel.options = arraySerie;
      } else if (value[i].segment_id === value[i - 1].segment_id) {
        let objSerie = {};
        objSerie.value = value[i].id;
        objSerie.label = value[i].name;
        arraySerie.push(objSerie);
        objNivel.options = arraySerie;
      } else {
        optionSerie.push(objNivel);
        objNivel = {};
        arraySerie = [];
        objNivel.label = nameSegment(value[i].segment_id);
        let objSerie = {};
        objSerie.value = value[i].id;
        objSerie.label = value[i].name;
        arraySerie.push(objSerie);
        objNivel.options = arraySerie;
      }

      if (i === value.length - 1) {
        optionSerie.push(objNivel);
      }
    }

    return optionSerie;
  }

  abilitySeriesMount(abilitySerie, serie) {
    let abilitySerieArray = [];
    for (let i = 0; i < abilitySerie.length; i++) {
      let obj = {};
      obj.value = abilitySerie[i].serie_id;
      for (let j = 0; j < serie.length; j++) {
        if (abilitySerie[i].serie_id === serie[j].id) {
          obj.label = serie[j].name;
          break;
        }
      }
      abilitySerieArray.push(obj);
    }

    return abilitySerieArray;
  }

  handleObjectiveChange(e) {
    const selectedValue = e.target.value;
    this.setState({ selectedObjective: selectedValue });
  }

  enviar(value) {
    this.setState({ creating: true });

    let abilitySerie = [];
    for (let i = 0; i < this.state.ability_serie.length; i++) {
      abilitySerie[i] = this.state.ability_serie[i].value;
    }
    let obj = {
      type: "bncc",
      code: value.code,
      description: value.description,
      objective_id: this.state.selectedObjective,
      serie: abilitySerie
    };

    if (obj.serie.length === 0) {
      this.error("Favor selecione pelo menos uma série.");
    } else if (!obj.objective_id) {
      this.error("Favor selecione um objetivo.");
    } else {
      axios
        .post(`${URL.api}classification/ability/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            this.props.history.push("/ability/list");
            this.setState({ creating: false });
          },
          error => {
            this.error("Não foi possível criar a habilidade");
            this.setState({ creating: false });
          }
        );
    }
  }

  atualizar(value) {
    this.setState({ creating: true });

    let abilitySerie = [];
    for (let i = 0; i < this.state.ability_serie.length; i++) {
      abilitySerie[i] = this.state.ability_serie[i].value;
    }
    let obj = {
      type: "bncc",
      code: value.code,
      description: value.description,
      objective_id: this.state.selectedObjective,
      serie: abilitySerie
    };

    if (obj.serie.length === 0) {
      this.error("Favor selecione pelo menos uma série.");
    } else if (!obj.objective_id) {
      this.error("Favor selecione um objetivo.");
    } else {
      axios
        .post(`${URL.api}classification/ability/update/${value.id}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            this.props.history.push("/ability/list");
            this.setState({ creating: false });
          },
          error => {
            this.error("Não foi possível editar a habilidade");
            this.setState({ creating: false });
          }
        );
    }
  }

  optionsChange = e => {
    this.setState({
      ability_serie: e
    });
  };

  render() {
    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/ability/list", to: "/ability/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Habilidade" : "Criar Habilidade"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a habilidade selecionada"
                    : "Crie uma nova habilidade"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={this.state.fields}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.ability}
                edit={this.state.edit}
                ref={this.formRef}
              />

              {/* Select manual para Objetivo */}
              <CFormGroup>
                <CLabel htmlFor="objective_id">
                  Objetivo <span className="text-danger">*</span>
                </CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-bullseye"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    id="objective_id"
                    value={this.state.selectedObjective}
                    onChange={this.handleObjectiveChange}
                    required
                    style={{ color: "#000" }}
                  >
                    <option value="" style={{ color: "#6c757d" }}>
                      Selecione um Objetivo
                    </option>
                    {this.state.objectiveOptions.map(option => (
                      <option
                        key={option.value}
                        value={option.value}
                        title={option.label}
                        style={{ whiteSpace: "normal" }}
                      >
                        {option.label.length > this.state.maxLabelLength
                          ? `${option.label.slice(
                              0,
                              this.state.maxLabelLength
                            )}…`
                          : option.label}
                      </option>
                    ))}
                  </CSelect>
                </CInputGroup>
              </CFormGroup>

              <CFormGroup>
                <CLabel>Segmento</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-layer-group"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <Select
                    isMulti
                    placeholder="Segmento"
                    name="Segmento"
                    options={this.state.serie}
                    defaultValue={this.state.ability_serie}
                    className="basic-multi-select flex-1 w-auto"
                    classNamePrefix="select"
                    onChange={e => this.optionsChange(e)}
                  />
                </CInputGroup>
              </CFormGroup>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AbilityCreate);
